import {Group, type IAccessClaim, type IAccessClaimParser, Policy} from '@igp/shared/access-control';
import type {User} from 'oidc-client-ts';

type PolicyValue = string | Record<string, string[]>;

export class BoAgentAccessClaimParser implements IAccessClaimParser<User> {
    public parse(user: User): IAccessClaim[] {
        return [...this.getGroups(user), ...this.getPolicies(user)];
    }

    private getPolicies(user: User): IAccessClaim[] {
        const policies = (user?.profile?.policies as PolicyValue) ?? {};

        return [...new Set(Object.values(policies).flat())].map(policyName => new Policy(policyName));
    }

    private getGroups(user: User): IAccessClaim[] {
        const groupPaths = (user?.profile?.groups as string[])?.filter(Boolean) ?? [];
        return groupPaths.map(path => path.split('/').pop() ?? '').map(groupName => new Group(groupName));
    }
}
